<template>
  <div>
    <vs-card>
      <b-row>
        <b-col lg="5">
          <b-row v-if="ROLE != 'Company'">
            <b-col cols="3" align-self="center">
              <b-form-group :label="'* ' + $t('Customer')" label-for="h-first-name">
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <v-select
                color="danger"
                v-model="customer"
                :options="customer_choices"
                size="small"
                label="name"
                v-on:input="getCompletedOrders"
                autocomplete
                ref="selectElement"
                name="customer"
                v-validate="'required'"
              >
              </v-select>

              <span class="text-danger text-sm" v-show="errors.has('customer')">{{
                errors.first("customer")
              }}</span>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <b-button
            style="border-color: white"
            v-on:click="getCompletedOrders()"
            class="vs-con-loading__container bg-primary"
            id="loading-orderList"
          >
            <Icon
              icon="mdi:tag-outline"
              style="margin-right: 5px"
              width="20"
              height="20"
            />{{ $t("ListOrder") }}
          </b-button>
        </b-col>
      </b-row>
    </vs-card>
    <vs-card>
      <ag-grid-vue
        ref="agGridTable"
        class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
        :columnDefs="columnsProcess"
        :defaultColDef="defaultColDef"
        :rowData="processList"
        rowSelection="single"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        @grid-ready="onGridReadyProcess"
        :suppressCopyRowsToClipboard="true"
        :localeText="localeText"
        :suppressRowClickSelection="true"
      >
      </ag-grid-vue>
    </vs-card>
    <OrderDetails
      :isSidebarActive="orderDetailPopupActive"
      :data="paramDetail"
      @closeSidebar="toggleDataSidebar"
    />
    <vs-popup
      class="holamundo"
      :title="$t('PrintOrder')"
      :active.sync="popupOrdersPrint"
      fullscreen
    >
      <OrderPrint :data="paramDetail" />
    </vs-popup>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import vSelect from "vue-select";
import twoInfoButtonsDynamic from "../CellRenderers/twoInfoButtonsDynamic.vue";
import OrderDetails from "./OrderDetails.vue";
import OrderPrint from "./OrderPrint.vue";
import moment from "moment";
export default {
  data() {
    return {
      popupOrdersPrint: false,
      orderDetailPopupActive: false,
      customer: "",
      customer_choices: [],
      ROLE: this.$store.state.AppActiveUser.ROLE,
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      processList: [],
      columnsProcess: [],
      completedOrders: [],
      paramDetail: [],
    };
  },
  components: {
    Icon,
    OrderPrint,
    OrderDetails,
    twoInfoButtonsDynamic,
    AgGridVue,
    vSelect,
  },
  methods: {
    orderDetail() {
      this.orderDetailPopupActive = true;
    },
    toggleDataSidebar(val = false) {
      this.orderDetailPopupActive = val;
    },
    getCustomerList(id, popup) {
      this.customerListOption = [];
      this.customer_choices = [];
      this.customerListOption = this.companydata;
      this.customerListOption.forEach((val, index) => {
        this.customer_choices.push({ value: val.CompanyId, name: val.CompanyName });
      });
    },
    onGridReadyProcess(params) {
      this.gridApiProcess = params.api;
      this.gridColumnApiProcess = params.columnApi;
    },
		parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY HH:mm");
    },
    getCompletedOrders() {
      const vs = this.$vs;
      let type = "material";
      vs.loading({
        container: `#loading-orderList`,
        type,
        scale: 0.5,
      });
      this.columnsProcess = [];
      this.$store
        .dispatch("order/listOrder", this.customer.value)
        .then((response) => {
          setTimeout(() => {
            vs.loading.close("#loading-orderList > .con-vs-loading");
          }, 1000);
          if (response.success == true) {
            this.completedOrders = JSON.parse(response.json);
            this.isSidebarActiveLocal = true;
            let columnList = Object.keys(this.completedOrders[0]);
            this.processList = this.completedOrders;
            this.columnsProcess.push({
              pinned: "left",
              width: 130,
              pinned: "left",
              cellRendererFramework: "twoInfoButtonsDynamic",
              cellRendererParams: {
                detailMethodsOne: "orderDetail",
                tooltipOne: "OrderDetail",
                iconDetailOne: "uil:search",
                iconColorOne: "#065a82",
                detailMethodsTwo: "printOrder",
                tooltipTwo: "PrintOrder",
                iconDetailTwo: "material-symbols:print-outline",
                iconColorTwo: "#ffcb77",
              },
            });
            columnList.forEach((val, index) => {
              if (val.toString() == "MarketPlaceName") {
                this.columnsProcess.push({
                  headerName: this.$t(val),
                  field: val,
                  filter: "agSetColumnFilter",
                  editable: true,
                  cellEditor: "agRichSelectCellEditor",
                  cellEditorParams: { cellHeight: 20, values: this.mpOPTION },
                  //  cellEditorParams: this.mpOPTION,
                });
              } else if (val.toString().includes("Date") == true)
                this.columnsProcess.push({
                  headerName: this.$t(val),
                  field: val,
                  filter: "agSetColumnFilter",
									valueFormatter: (params) => this.parseDate(params.data[val]),
                  editable: true,
                });
              else if (
                val.toString().includes("Id") == false &&
                val.toString().includes("TrasnType") == false
              )
                this.columnsProcess.push({
                  headerName: this.$t(val),
                  field: val,
                  filter: "agSetColumnFilter",
                  editable: true,
                });
            });
          } else console.log(response.statusText);
        })
        .catch((error) => {
          setTimeout(() => {
            vs.loading.close("#loading-orderList > .con-vs-loading");
          }, 1000);
          console.log(error);
        });
    },
    printOrder() {},
  },
  created() {
    // this.getCompletedOrders();
    this.getCustomerList();
  },
  computed: {
    localeText() {
      return i18nData[this.$i18n.locale];
    },
    companydata: {
      get() {
        return this.$store.state.customer.Customer;
      },
      set(val) {
        if (!val) {
        }
      },
    },
  },
  watch: {
    companydata(val) {
      this.getCustomerList();
      return val;
    },
  },
  mounted() {
    this.$root.$on("orderDetail", (paramDetail) => {
      this.paramDetail = paramDetail;
      this.orderDetail();
    });
    this.$root.$on("printOrder", (paramDetail) => {
      this.paramDetail = paramDetail;
      this.popupOrdersPrint = true;
    });
  },
  beforeDestroy() {
    this.$root.$off("orderDetail");
    this.$root.$off("printOrder");
  },
};
</script>
<style lang="scss">
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 130px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
